exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-39b2c32a] .el-card__body{height:100%}[data-v-39b2c32a] .el-carousel__indicators--horizontal{top:0}.customebg-color-danger[data-v-39b2c32a]{background-color:#ff3a30}.customebg-color-alarm[data-v-39b2c32a]{background-color:#ff9502}.customebg-color-risk[data-v-39b2c32a]{background-color:#f8b200}.customebg-color-primary[data-v-39b2c32a]{background-color:#0082f7}", ""]);

// exports
